import { useEffect, useState } from 'react';
import axios from 'axios';
import MainURL from '../MainURL';
import './Admin.scss';

interface SongItem {
	id: number;
	bookletId: string;
	title: string;
	stateSort: string;
	keySort: string;
	tempoSort: string;
	theme: string;
	image: string;
}

export default function Sub4_Backup() {


	return (
		<div className="Main-cover">

			

			<div style={{ height: '100px' }} />
		</div>
	);
}
